import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import './Icon.scss'; // Assuming you have a CSS file for styling

const Icon = ({
  icon,
  size = '1x',
  color,
  className = '',
  spin = false,
  pulse = false,
  rotation,
  flip,
  onClick,
  style = {},
  ...props
}) => {
  const iconStyle = {
    ...style,
    ...(color && { color })
  };

  return (
    <FontAwesomeIcon
      icon={icon}
      size={size}
      className={className}
      spin={spin}
      pulse={pulse}
      rotation={rotation}
      flip={flip}
      onClick={onClick}
      style={iconStyle}
      {...props}
    />
  );
};

Icon.propTypes = {
  icon: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object
  ]).isRequired,
  size: PropTypes.oneOf([
    'xs', 'sm', 'lg', 'xl', '2xl', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x'
  ]),
  color: PropTypes.string,
  className: PropTypes.string,
  spin: PropTypes.bool,
  pulse: PropTypes.bool,
  rotation: PropTypes.oneOf([90, 180, 270]),
  flip: PropTypes.oneOf(['horizontal', 'vertical', 'both']),
  onClick: PropTypes.func,
  style: PropTypes.object
};

export default Icon;